import React from 'react';
import { FaTimes, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const Modal = ({ isOpen, message, type = 'info', onClose }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return <FaTimes className="mr-2" />;
      case 'success':
        return <FaCheckCircle className="mr-2" />;
      default:
        return <FaExclamationTriangle className="mr-2" />;
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case 'error':
        return 'border-red-400';
      case 'success':
        return 'border-green-400';
      default:
        return 'border-blue-400';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'error':
        return 'text-red-600';
      case 'success':
        return 'text-green-600';
      default:
        return 'text-blue-600';
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className={`bg-white rounded-xl shadow-2xl max-w-sm w-full mx-auto p-6 border-2 ${getBorderColor()}`}>
        <div className={`text-lg font-bold mb-2 flex items-center ${getTextColor()}`}>
          {getIcon()}
          {type === 'error' ? 'Error' : type === 'success' ? 'Success' : 'Info'}
        </div>
        <div className="mb-4 text-gray-700">{message}</div>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium w-full"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;